import { useEffect, useRef } from "react";
import { LangPacksDOM } from "./utils/langPacksDom";
import { getCurrentUserId } from "./awsAuth";

const API_BASE =
  process.env.REACT_APP_API_BASE ||
  process.env.REACT_APP_API ||
  (typeof window !== "undefined" &&
  window.location.hostname.includes("onrender.com")
    ? "https://cvanto-api.onrender.com"
    : "");

const apiUrl = (path) =>
  path.startsWith("http://") || path.startsWith("https://")
    ? path
    : `${API_BASE || ""}${path}`;

export default function AppBoot({ children }) {
  const ref = useRef(null);

  useEffect(() => {
    ref.current = new LangPacksDOM({ scopeSelector: '#root' });

    window.cvantoSetLang = (lang) => ref.current?.setLang(lang);

    const onSet = (e) => ref.current?.setLang(e.detail?.lang || 'uk');
    window.addEventListener('cvanto:set-lang', onSet);

    return () => {
      window.removeEventListener('cvanto:set-lang', onSet);
      delete window.cvantoSetLang;
      ref.current?.setLang('uk');
    };
  }, []);

    useEffect(() => {
    (async () => {
      const lang = localStorage.getItem('cvanto_lang') === 'en' ? 'en' : 'uk';
      await ref.current?.setLang(lang);
    })();
  }, []);

  return children;
}
